import { render, staticRenderFns } from "./Cinema.vue?vue&type=template&id=a0b44056&"
import script from "./Cinema.vue?vue&type=script&lang=js&"
export * from "./Cinema.vue?vue&type=script&lang=js&"
import style0 from "./Cinema.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports